import junglehouse from '../assets/junglehouse.png'
import ChatWeb from '../assets/chat.png'
import calculatorapp from '../assets/calculatorapp.png'
import portfoilodemo from '../assets/portfolio demo0 .gif.png'
import AMS from '../assets/AMS.png'
import soursecode1 from '../assets/soursecode1.jpg'
import soursecode2 from '../assets/soursecode2.jpeg'
import soursecode3 from '../assets/soursecode3.jpg'
import portfolio2024 from '../assets/portfolio2024 .gif'
const projectsData = [
    {
        id: 1,
        title: "portfolio2024",
        description:"This is my portfolio website the first version and it's my first my way to practise my skills in web development specially in react.js without any follow up with any course or tutorial" ,
        image:portfolio2024,
        link:"https://github.com/mohamedreda22/portfolio2024"

    },
    {
        id:2,
        title:"Auction management system (AMS)",
        description:"It's my first project with the Reactjs framework working for my college project",
        image:AMS,
        link:"https://github.com/mohamedreda22/FCAIH.eg"
    },
    {
        id:3,
        title:"jungle-house",
        description:"It's my second project with the React.js framework working with (open classrooms blog)",
        image: junglehouse,
        link:"https://github.com/mohamedreda22/jungle-house",
        live:"https://mohamedreda22.github.io/jungle-house"
        
    },

    {
        id:4,
        title:"chat web application (Demo)",
        description:"Shardings Meet (React.js Assignment)",
        image: ChatWeb,
        link:"https://github.com/mohamedreda22/chat-web-application",
        live:"https://mohamedreda22.github.io/chat-web-application/"
    },
    {
        id:5,
        title:"Calculator app",
        description:"This is my assignment to practice the knowledge gained from this course! (react basics by Coursera )",
        image: calculatorapp,
        link:"https://github.com/mohamedreda22/Calculator-app"
    },
    {
        id:6,
        title:"Portfolio",
        description:"It's a demo portfolio not about me (demo for my course);",
        image:portfoilodemo,
        link:"https://github.com/mohamedreda22/portfolio"
    },
    {
        id:7,
        title:"Advanced React (Source code)",
        description:"This is the source code I wrote throughout my course journey (Advanced React Coursera)",
        image:soursecode1,
        link:"https://github.com/mohamedreda22/advanced-react"
    },
    {
        id:8,
        title:"Algorithms Course (source code)",
        description:"You will find the source code and solutions I wrote while learning algorithms in my Algorithms Course in this repository. Algorithms are a fundamental part of computer science and play a crucial role in solving complex problems efficiently. I created this repository to showcase my progress and share my knowledge with others interested in algorithms.",
        image:soursecode2,
        link:"https://github.com/mohamedreda22/Algorithms-Course"
    },
    {
        id:9,
        title:"segregateNumbers ",
        description:"This is my task for my algorithms course ",
        image:soursecode3,
        link:"https://github.com/mohamedreda22/segregateNumbers"
    },
    ]
export default projectsData;
        